import './Banner.css'

export const Banner = () => {
    // JSX
    return (
        <header className="banner">
            <img src="/imagens/BANNER-BRASIL.png" alt="O banner principal da página"/>
        </header>
    )
}